import { render } from "./BookViewLocations.vue?vue&type=template&id=563ea332&scoped=true"
import script from "./BookViewLocations.vue?vue&type=script&lang=js"
export * from "./BookViewLocations.vue?vue&type=script&lang=js"

import "./BookViewLocations.vue?vue&type=style&index=0&id=563ea332&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-563ea332"

export default script